import { WELL_FIELDS_LIST, WELL_FIELDS_LIST_ERROR, WELL_FIELDS_LIST_SUCCESS, WELL_FIELDS_PLOT, WELL_FIELDS_PLOT_ERROR, WELL_FIELDS_PLOT_SUCCESS, WELL_FIELDS_UPDATE_DATA } from './constants';

export default function wellFieldsReducer(state, action) {
	switch (action.type) {
	case WELL_FIELDS_LIST :
		return { ...state, loading : true, error : false };
	case WELL_FIELDS_LIST_SUCCESS :
		return { ...state,wellFields : action.payload, loading : false, error : false};
	case WELL_FIELDS_LIST_ERROR : 
		return { ...state, loading : false, error : true };
	case WELL_FIELDS_UPDATE_DATA :
		return { ...state, updateData : action.payload };

	case WELL_FIELDS_PLOT :
		return { ...state, loading : true, error : false };
	case WELL_FIELDS_PLOT_SUCCESS :
		return { ...state,FieldwellData : action.payload, loading : false, error : false};
	case WELL_FIELDS_PLOT_ERROR : 
		return { ...state, loading : false, error : true };


	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}